module.exports = __webpack_public_path__ + "static/img/VdA_Logo_III.08af621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/VdA_Logo_III.jpg
// module id = 595
// module chunks = 1